import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { queryClient } from "App";

export interface InvestmentTypePreference {
  slug: string;
  section: "own" | "reliance";
  order: number;
  isExpanded: boolean;
}

export interface UpdatePreferencesPayload {
  preferences: InvestmentTypePreference[];
}

export const useUpdateInvestmentPreferences = (
  options?: UseMutationOptions<any, Error, UpdatePreferencesPayload>
) => {
  return useMutation({
    ...options,
    mutationKey: ["updateInvestmentPreferences"],
    mutationFn: async (data: UpdatePreferencesPayload) => {
      return axiosInstance
        .put("/investment-types/preferences", data)
        .then((res) => res.data);
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["investments/grouped"] });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
  });
};
